module.exports = __webpack_public_path__ + "img/pin_transport_orange.5e7c0af8.svg";